/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 * @flow
 */

import Container from 'components/Container';
import ExternalFooterLink from './ExternalFooterLink';
import FooterLink from './FooterLink';
import FooterNav from './FooterNav';
import MetaTitle from 'templates/components/MetaTitle';
import React from 'react';
import {colors, media} from 'theme';
import {sectionListDesign} from 'utils/sectionList';

const Footer = ({layoutHasSidebar = false}: {layoutHasSidebar: boolean}) => (
  <footer
    css={{
      backgroundColor: colors.darker,
      color: colors.white,
      paddingTop: 10,
      paddingBottom: 50,

      [media.size('sidebarFixed')]: {
        paddingTop: 40,
      },
    }}>
    <Container>
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',

          [media.between('small', 'medium')]: {
            paddingRight: layoutHasSidebar ? 240 : null,
          },

          [media.between('large', 'largerSidebar')]: {
            paddingRight: layoutHasSidebar ? 280 : null,
          },
          [media.between('largerSidebar', 'sidebarFixed', true)]: {
            paddingRight: layoutHasSidebar ? 380 : null,
          },
        }}>
        <div
          css={{
            flexWrap: 'wrap',
            display: 'flex',

            [media.lessThan('large')]: {
              width: '100%',
            },
            [media.greaterThan('xlarge')]: {
              width: 'calc(100% / 3 * 2)',
              paddingLeft: 40,
            },
          }}>
          <FooterNav layoutHasSidebar={layoutHasSidebar}>
            <MetaTitle onDark={true}>应用设计</MetaTitle>
            {sectionListDesign.map(section => {
              const defaultItem = section.items[0];
              return (
                <FooterLink
                  to={`/design/${defaultItem.id}.html`}
                  key={section.title}>
                  {section.title}
                </FooterLink>
              );
            })}
          </FooterNav>
          {/* <FooterNav layoutHasSidebar={layoutHasSidebar}>
            <MetaTitle onDark={true}>Channels</MetaTitle>
            <ExternalFooterLink
              href="https://zhibeifw.com/"
              target="_blank"
              rel="noopener">
              智悲佛网
            </ExternalFooterLink>
            <ExternalFooterLink
              href="http://yt.zhibeijiaoyu.com/forum.php"
              target="_blank"
              rel="noopener">
              智悲论坛
            </ExternalFooterLink>
            <ExternalFooterLink
              href="https://kingsforum.herokuapp.com"
              target="_blank"
              rel="noopener">
              闻思修论坛
            </ExternalFooterLink>
          </FooterNav> */}
          <FooterNav layoutHasSidebar={layoutHasSidebar}>
            <MetaTitle onDark={true}>更多</MetaTitle>
            <FooterLink to="/design/change-log.html">应用使用教程</FooterLink>
            <FooterLink to="/blog/">博客</FooterLink>
            <FooterLink to="/acknowledgements.html">
              致谢
            </FooterLink>
          </FooterNav>
        </div>
        <section
          css={{
            paddingTop: 40,
            display: 'block !important', // Override 'Installation' <style> specifics

            [media.greaterThan('xlarge')]: {
              width: 'calc(100% / 3)',
              order: -1,
            },
            [media.greaterThan('large')]: {
              order: -1,
              width: layoutHasSidebar ? null : 'calc(100% / 3)',
            },
            [media.lessThan('large')]: {
              textAlign: 'center',
              width: '100%',
              paddingTop: 40,
            },
          }}>
          <p
            css={{
              color: colors.subtleOnDark,
              paddingTop: 15,
            }}>
            Copyright © 2018 Kingspress.
          </p>
        </section>
      </div>
    </Container>
  </footer>
);

export default Footer;
